import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { Tracking } from "core/tracking";
import { config } from "core/utils";
import React from "react";
import { View } from "./View";
import { teamToTeamView } from "./teamMapping";
export var Provider = function (_a) {
    var componentId = _a.componentId, teams = _a.teams, listName = _a.listName, trackingEnabled = _a.trackingEnabled, className = _a.className;
    var _b = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _b.ref, enteredViewport = _b.enteredViewport;
    if (trackingEnabled && enteredViewport) {
        Tracking.trackCollection(listName, teams);
    }
    var viewTeams = teams.map(function (team) { return teamToTeamView(team); });
    return (React.createElement(View, { componentId: componentId, teams: viewTeams, ref: ref, className: className }));
};
